import React from 'react';
import classNames from 'classnames';

import { NamedLink } from '../../../../../components';

import css from './ChipFilter.module.css';

/**
 * Horizontal pill-style filter for landing-page strips.
 *
 * Each chip is a NamedLink pointing back at the LandingPage with the
 * strip's chip param adjusted in the URL. The Routes infrastructure
 * re-runs LandingPage.loadData on any location change, so clicking a
 * chip is enough to refetch the strip with the new filter — no
 * imperative dispatch / useState required.
 *
 * @param {Object} props
 * @param {Array<{ key: string|null, label: string, to: { search: string } }>} props.chips
 * @param {string|null} props.selectedKey – `null` represents the "All" chip
 * @returns {JSX.Element}
 */
const ChipFilter = props => {
  const { chips, selectedKey } = props;

  return (
    <div className={css.root} role="group">
      {chips.map(chip => {
        const isSelected = chip.key === selectedKey;
        return (
          <NamedLink
            key={chip.key ?? '__all__'}
            className={classNames(css.chip, { [css.chipSelected]: isSelected })}
            name="LandingPage"
            to={chip.to}
            aria-pressed={isSelected}
          >
            {chip.label}
          </NamedLink>
        );
      })}
    </div>
  );
};

export default ChipFilter;
